import React, { useRef } from 'react';
import AfCharts from '../../components/af-charts';
import PersonalInfoBox from '../../components/personal-info-box';
import { RecordSummeryBox } from '../../components/recording-summery-box';
import ReportHeader from '../../components/report-header';
import MonthlyCharts from '../../components/monthly-charts';
import '../../css/reports.css';
import ReportFooter from '../../components/footer-report';
import Watermark from '../../components/watermark';
import AnnotationsList from '../../components/annotations-list';
export default function MonthlyReportComponent({ data, isPdf }) {
    const refToPrint = useRef(null);
    console.log('ALL DATA', data);
    const { patientProfile: patient, patientQuestions, questionsScore, reportDates, appConfiguration, recording_summary_data, pulse_data, respiratory_data, diastolic_data, diastolic_manual_data, diastolic_external_data, systolic_data, systolic_manual_data, systolic_external_data, oxygenSaturation_data, oxygenSaturation_manual_data, oxygenSaturation_external_data, temperature_data, temperature_manual_data, temperature_external_data, weight_data, weight_manual_data, glucose_data, glucose_manual_data, hrv_data, steps_data, calories_data, af_data, af_detection_summary_data, histogram_data, isDemo, sleep_data, pwv_data, annotations_data, medications } = data;
    const chartsData = {
        pulseRateData: [pulse_data],
        respiratoryRateData: [respiratory_data],
        bloodPressureData: [systolic_data, systolic_manual_data, systolic_external_data, diastolic_data, diastolic_manual_data, diastolic_external_data],
        spo2Data: [oxygenSaturation_data, oxygenSaturation_manual_data, oxygenSaturation_external_data],
        bodyTempData: [temperature_data, temperature_manual_data, temperature_external_data],
        weightData: [weight_data, weight_manual_data],
        glucoseData: [glucose_data, glucose_manual_data],
        stepsData: [steps_data],
        caloriesData: [calories_data],
        hrvData: [hrv_data.rmsdd_pulse],
        lfhfData: [hrv_data === null || hrv_data === void 0 ? void 0 : hrv_data.lfhf],
        sleepData: [sleep_data],
        pwvData: [pwv_data]
    };
    const afChartsData = {
        af_data,
        af_detection_summary_data,
        histogram_data,
    };
    return (React.createElement("div", { ref: refToPrint, className: `wrap-report wrap-monthly-report ${isPdf ? 'is-pdf' : 'is-not-pdf'}` },
        React.createElement(ReportHeader, { title: 'Monthly Report', user: patient, isPdf: isPdf, startDate: reportDates === null || reportDates === void 0 ? void 0 : reportDates.start, endDate: reportDates === null || reportDates === void 0 ? void 0 : reportDates.end, refToPrint: refToPrint, timezoneOffset: isPdf ? patient.time_zone : 999 }),
        React.createElement(PersonalInfoBox, { user: patient, patientQuestions: patientQuestions, questionsScore: questionsScore, medications: medications }),
        React.createElement(RecordSummeryBox, { recordingData: recording_summary_data, reportDates: reportDates }),
        React.createElement(MonthlyCharts, { chartsData: chartsData, configurations: appConfiguration, user: patient, isPdf: isPdf }),
        React.createElement(AnnotationsList, { annotations: annotations_data }),
        isPdf &&
            React.createElement(React.Fragment, null,
                React.createElement(AfCharts, { afChartsData: afChartsData, isPdf: isPdf }),
                React.createElement(ReportFooter, null),
                isDemo && React.createElement(Watermark, null))));
}
